<template>
  <table class="table table-details">
    <tr>
      <td><label>{{ $t('generic.id') }}</label></td>
      <td>{{ details.id }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('topUp.details.account_id') }}</label></td>
      <td><router-link :to="accountLinkUrl(details)">{{
          details.account_id
        }}
      </router-link></td>
    </tr>
    <tr>
      <td><label>{{ $t('topUp.details.initiator_ip') }}</label></td>
      <td>{{ details.initiator_ip }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('generic.created') }}</label></td>
      <td>{{ details.created_at | time }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('generic.updated') }}</label></td>
      <td>{{ details.updated_at | time }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('topUp.details.amount') }}</label></td>
      <td>{{ details.amount | price }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('generic.status') }}</label></td>
      <td>{{ details.status }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('generic.type') }}</label></td>
      <td>{{ details.type }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('topUp.details.card_pan') }}</label></td>
      <td><span v-if="details.card_pan_suffix">**** **** **** {{ details.card_pan_suffix }}</span></td>
    </tr>
    <tr>
      <td><label>{{ $t('topUp.details.card_expiry') }}</label></td>
      <td>{{ details.card_expiry }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('topUp.details.distributors_company_name') }}</label></td>
      <td>{{ details.distributors_company_name }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('topUp.details.merchant_reference') }}</label></td>
      <td>{{ details.merchant_reference }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('topUp.details.payment_reference') }}</label></td>
      <td>{{ details.payment_reference }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('topUp.details.origin') }}</label></td>
      <td>{{ details.origin }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('topUp.details.initiated_at') }}</label></td>
      <td><span v-if="details.initiated_at">{{ details.initiated_at | time }}</span></td>
    </tr>
    <tr>
      <td><label>{{ $t('topUp.details.applied_at') }}</label></td>
      <td><span v-if="details.applied_at">{{ details.applied_at | time }}</span></td>
    </tr>
    <tr>
      <td><label>{{ $t('generic.metadata') }}</label></td>
      <td><meta-data-details :data="details.metadata"/></td>
    </tr>
    <tr>
      <td><label>{{ $t('topUp.details.failure_reason') }}</label></td>
      <td><meta-data-details :data="details.failure_reason" /></td>
    </tr>
    <tr>
      <td><label>{{ $t('topUp.details.retries') }}</label></td>
      <td>{{ details.retries }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('topUp.details.failures') }}</label></td>
      <td>
        <top-up-failures-table v-if="details.failures" :data="details.failures"/>
      </td>
    </tr>
  </table>
</template>
<script>
import TopUpFailuresTable from './TopUpFailuresTable'
import MetaDataDetails from "@/components/MetaData/MetaDataDetails.vue";
import linkUtils from "@/util/link_utils";

export default {
  name: 'topUpDetails',
  components: {
    MetaDataDetails,
    TopUpFailuresTable
  },
  props: {
    details: {
      type: Object,
      required: true,
    },
  },
  methods: {
    accountLinkUrl(details) {
      return linkUtils.accountTopUpPath(this.$router, {account_id: details.account_id, top_up_id: details.id});
    },
  }
};
</script>
<style></style>
